import {Avatar, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import React from "react";
import {deepOrange} from "@mui/material/colors";

const ListTile = (props) => {
    const {selected,item,handleToggle,disabled,showAvatar} = props;


    return (<ListItem
        disablePadding
    >
        <ListItemButton role={undefined}
                        disabled={disabled}
                        onClick={()=>handleToggle(item)}
                        dense>
            <ListItemIcon>
                {showAvatar ? <Avatar
                    sx={{ bgcolor: deepOrange[500] }}
                    alt="Remy Sharp"
                /> : <Checkbox
                    edge="start"
                    checked={selected}
                    tabIndex={-1}
                    disabled={disabled}
                    onClick={(event) => {
                        event.stopPropagation();
                        handleToggle(item)
                    }}
                    disableRipple
                    // inputProps={{ 'aria-labelledby': labelId }}
                />}

            </ListItemIcon>
            <ListItemText primary={item.label} secondary={item.secondary} />
        </ListItemButton>
    </ListItem>);
}


export default ListTile;
